import { Card, Grid, Typography, Box, Chip, Button, Stack, ButtonBase } from "@mui/material";
import React from "react";

export default function ServiceCard({
    imgUrl,
    name,
    remarks = [],
    isSelected = false,
    onSelect = () => { },
    onConfig = () => { },
    onCustomize = () => { },
    isSaved = false,
    alias = ''
}) {
    return (
        <Card
            sx={{
                p: 2,
                border: isSelected ? "1px solid #1976d2" : "1px solid #e0e0e0",
                borderRadius: 2,
                boxShadow: isSelected ? 4 : 1,
                cursor: "pointer",
                transition: "all 0.2s ease",
                "&:hover": {
                    boxShadow: 4,
                },
                height: '100%'
            }}
        >
            <Grid container spacing={2} alignItems="center">
                {/* Left Side: Text */}
                <Grid item md={8} xs={12}>
                    {/* Name */}
                    <Typography
                        variant="subtitle1"
                        fontWeight="bold"
                        sx={{ mb: 1, color: isSelected ? "primary.main" : "text.primary" }}
                    >
                        {name}
                    </Typography>

                    {/* Remarks */}
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                        {remarks.length > 0 ? (
                            <Stack>
                                {
                                    remarks.map((remark, idx) => (
                                        <Typography key={idx} variant="body2" color="text.secondary">
                                            {remark}
                                        </Typography>
                                    ))
                                }
                            </Stack>

                        ) : (
                            <Typography variant="body2" color="text.secondary">
                                No remarks
                            </Typography>
                        )}
                    </Box>

                    <Stack flexDirection={'row'} gap={1} alignItems={'flex-end'}>
                        <Button
                            size="small"
                            onClick={onSelect}
                            sx={{ display: 'block', mt: 2 }} variant={isSelected ? 'contained' : 'outlined'}>{isSelected ? 'Selected' : 'Select'}</Button>

                        {["PASSPORT_PHOTOS", "DOCUMENTS"]?.includes(alias) && isSaved && (
                            <ButtonBase onClick={onConfig}><Typography variant="caption" sx={{ textDecoration: 'underline' }}>Configuration</Typography></ButtonBase>
                        )}

                        {isSelected
                            &&
                            <ButtonBase onClick={onCustomize}>
                                <Typography variant="caption" sx={{ textDecoration: 'underline' }}>
                                    Edit
                                </Typography>
                            </ButtonBase>

                        }
                    </Stack>
                </Grid>

                {/* Right Side: Image */}
                <Grid
                    item
                    md={4}
                    xs={12}
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    {imgUrl ? (
                        <Box
                            component="img"
                            src={typeof imgUrl === 'string' ? imgUrl : URL.createObjectURL(imgUrl)}
                            alt={name}
                            sx={{
                                maxWidth: 120,
                                maxHeight: 120,
                                height: "auto",
                                borderRadius: 2,
                                objectFit: "cover",
                            }}
                        />
                    ) : (
                        <Box
                            sx={{
                                width: 100,
                                height: 80,
                                borderRadius: 2,
                                bgcolor: "grey.200",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                color: "text.secondary",
                                fontSize: 12,
                            }}
                        >
                            No Image
                        </Box>
                    )}
                </Grid>
            </Grid>
        </Card>
    );
}
